import type { FeatureFlagKey } from "@/schema"

import { ApiContext, apiContextFetch } from "@/hooks/api/base"

interface FeatureFlagsResponse {
  feature_flags: FeatureFlagKey[]
}

export function fetchFeatureFlags(context: ApiContext) {
  return apiContextFetch<FeatureFlagsResponse>(context, "feature_flags")
}
